import React, { useRef } from "react";
import AttendanceDailyBulkActionBar from "./AttendanceDailyBulkActionBar";
import AttendanceDailyCardGrid from "./AttendanceDailyCardGrid";
import AttendanceDailyListRows from "./AttendanceDailyListRows";
import AttendanceDailyStatusSummary from "./AttendanceDailyStatusSummary";
import useAttendanceMarqueeSelect from "./useAttendanceMarqueeSelect";

export default function AttendanceDailySection({
  GlassCard,
  brand,
  bulkHoverState,
  dailyAttendance,
  dailyStats,
  filteredStudents,
  handleBulkStatusChange,
  handleSaveDaily,
  handleSelectAll,
  handleSelectRow,
  handleStatusChange,
  handleSyncSoteria,
  handleClearSelection,
  isMobile,
  isSoteriaLoading,
  selectedDepartment,
  selectedIds,
  setBulkHoverState,
  targetGroup,
  theme,
  viewMode,
  handleMarkDragStart,
  handleSelectDragStart,
  handleDragOver,
  isDragging,
  dragStatus,
  setSelectedIds,
}) {
  const containerRef = useRef(null);
  const { handleMouseDown, renderSelectionBox, isSelecting } = useAttendanceMarqueeSelect(
    filteredStudents,
    setSelectedIds,
    containerRef,
    '.selection-item'
  );

  return (
    <div
      ref={containerRef}
      onMouseDown={handleMouseDown}
      className={`flex-1 overflow-auto relative select-none ${isMobile ? "p-0 pt-2" : "p-6"}`}
    >
      {renderSelectionBox()}
      <AttendanceDailyStatusSummary
        dailyStats={dailyStats}
        filteredCount={filteredStudents.length}
        isMobile={isMobile}
        theme={theme}
      />

      <AttendanceDailyBulkActionBar
        bulkHoverState={bulkHoverState}
        filteredCount={filteredStudents.length}
        handleBulkStatusChange={handleBulkStatusChange}
        handleClearSelection={handleClearSelection}
        handleSaveDaily={handleSaveDaily}
        handleSelectAll={handleSelectAll}
        handleSyncSoteria={handleSyncSoteria}
        isMobile={isMobile}
        isSoteriaLoading={isSoteriaLoading}
        selectedCount={selectedIds.length}
        setBulkHoverState={setBulkHoverState}
        theme={theme}
        handleMarkDragStart={handleMarkDragStart}
      />

      {viewMode === "card" ? (
        <AttendanceDailyCardGrid
          GlassCard={GlassCard}
          dailyAttendance={dailyAttendance}
          filteredStudents={filteredStudents}
          handleSelectRow={handleSelectRow}
          handleStatusChange={handleStatusChange}
          selectedIds={selectedIds}
          targetGroup={targetGroup}
          selectedDepartment={selectedDepartment}
          handleMarkDragStart={handleMarkDragStart}
          handleSelectDragStart={handleSelectDragStart}
          handleDragOver={handleDragOver}
          isDragging={isDragging}
          dragStatus={dragStatus}
        />
      ) : (
        <AttendanceDailyListRows
          brand={brand}
          dailyAttendance={dailyAttendance}
          filteredStudents={filteredStudents}
          handleSelectRow={handleSelectRow}
          handleStatusChange={handleStatusChange}
          isMobile={isMobile}
          selectedDepartment={selectedDepartment}
          selectedIds={selectedIds}
          targetGroup={targetGroup}
          handleMarkDragStart={handleMarkDragStart}
          handleSelectDragStart={handleSelectDragStart}
          handleDragOver={handleDragOver}
          isDragging={isDragging}
          dragStatus={dragStatus}
        />
      )}
    </div>
  );
}
